import { MenuItem, TextField } from "@mui/material";
import React from "react";
import { toast } from "react-toastify";
import { branch } from "../../../common/type";

const index = (props: { register: any; handleSubmit: any; errors: any; branch: any; formValue: any; setFormValue: any; handleNext: any; }) => {
  const onError = (data: any) => {
    toast.error(data[Object.keys(data)[0]].message, {
      theme: "colored",
    });
  };

  const onSubmit = (data: any) => {
    props.setFormValue({
      ...props.formValue,
      dob: data.dob,
      firstName: data.firstName,
      middleName: data.middleName,
      lastName: data.lastName,
      gender: data.gender,
      phoneNo: data.phoneNo,
      branchId: data.branchId,
    });

    props.handleNext();
  };

  var date = new Date()
  var dateMax = new Date()
  var dateMin = new Date()
  dateMax.setFullYear(date.getFullYear() - 1)
  dateMin.setFullYear(date.getFullYear() - 100)

  return <form id="page1" onSubmit={props.handleSubmit(onSubmit, onError)}>
    <div className="grid grid-cols-2 gap-2">
      <div>
        <TextField size="small" fullWidth label="First Name" name="firstName" {...props.register("firstName")} error={props.errors?.firstName ? true : false} />
        <p color="error" className="text-red-700 text-sm">{props.errors?.firstName?.message}</p>
      </div>
      <div>
        <TextField size="small" fullWidth label="Phone Number" name="phoneNo" {...props.register("phoneNo")} error={props.errors?.phoneNo ? true : false} />
        <p color="error" className="text-red-700 text-sm">{props.errors?.phoneNo?.message}</p>
      </div>
      <div>
        <TextField size="small" fullWidth label="Middle Name" name="middleName" {...props.register("middleName")} error={props.errors?.middleName ? true : false} />
        <p color="error" className="text-red-700 text-sm">{props.errors?.middleName?.message}</p>
      </div>
      <div>
        <TextField size="small" fullWidth label="Branch" select name="branchId" {...props.register("branchId")} defaultValue={props.formValue?.branchId}
          error={props.errors?.branchId ? true : false}>
          {props.branch?.map((br: branch) => (
            <MenuItem value={br.id}>{br.name}</MenuItem>
          ))}
        </TextField>
        <p color="error" className="text-red-700 text-sm">{props.errors?.branchId?.message}</p>
      </div>
      <div>
        <TextField size="small" fullWidth label="Last Name" variant="outlined" name="lastName" {...props.register("lastName")} error={props.errors?.lastName ? true : false} />
        <p color="error" className="text-red-700 text-sm">{props.errors?.lastName?.message}</p>
      </div>
      <div>
        <TextField size="small" fullWidth select label="Gender" variant="outlined" name="gender" {...props.register("gender")}
          error={props.errors?.gender ? true : false} defaultValue={props.formValue?.gender}>
          <MenuItem value={"male"}>Male</MenuItem>
          <MenuItem value={"female"}>Female</MenuItem>
        </TextField>
        <p color="error" className="text-red-700 text-sm">{props.errors?.gender?.message}</p>
      </div>
      <div>
        <TextField type="date" fullWidth size="small" label="Date of Birth" name="dob" {...props.register("dob")} error={props.errors?.dob ? true : false}
          inputProps={{ max: dateMax.toISOString().substring(0, 10), min: dateMin.toISOString().substring(0, 10) }}
          InputLabelProps={{
            shrink: true,
          }} />
        <p color="error" className="text-red-700 text-sm">{props.errors?.dob?.message}</p>
      </div>
    </div>
  </form>;
};

export default index;
